export const fetchOrderDetail = async (
  httpGet: Function,
  id: string,
): Promise<any> => {
  const response = await httpGet(`orders/detailVehicle/${id}`, undefined, false);
  if (response.status === 200) {
    return response.data;
  }
  return null;
};
